import style from './index.module.less';

export default function GroupTitle(props: { title: string | null; align?: 'left'; }) {

  if (!props.title) {
    return null;
  }

  return <>
    {
      props.title.split('\n').map((s) => {
        return <div className={`${style.groupTitle} ${props.align === 'left' ? style.left : ''}`} key={s}>{s}</div>;
      })
    }
  </>;

}
